import axios from 'axios';
import React, { useCallback, useEffect } from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { domainWeb } from '../../config/constants';
import { authenticated } from '../../recoil/auth';
import { contentLoading, contentOptions, contentSelected } from '../../recoil/content';

const RecordSelectContent = () => {
  const [loading, setLoading] = useRecoilState(contentLoading);
  const [data, setData] = useRecoilState(contentOptions);
  const setSelected = useSetRecoilState(contentSelected);
  const auth = useRecoilValue(authenticated);
  
  const getContents = useCallback( async () => {
    setLoading(true);
    try {
      let response = await axios.get(`${domainWeb}/contents/id-titles`, 
          {headers: {
              'Content-Type': 'application/json', 
              'Accept': 'application/json', 
              'Authorization': 'Bearer ' + auth.token
          }},
      );
      setLoading(false);
      setData(response.data);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }, [auth.token, setData, setLoading]);

  const handleOnChange = (e) => {
    setSelected(e.target.value);
  };
  
  useEffect(() => {
    getContents();
  }, [getContents]);

  return (
    <div className="flex items-center w-1/3 px-5 py-3 rounded-lg bg-slate-50">
      <select onChange={handleOnChange} className="w-full p-0 bg-transparent border-none focus:ring-0">
          <option value="">Semua Konten</option>
          { loading ? <option>Loading...</option> :Object.keys(data).map((keyName, i) => (
            <option key={i} value={data[i].id}>{data[i].title}</option>
          ))}
      </select>
    </div>
  );
}


export default RecordSelectContent